import React from "react";

const ContactForm = ({
  handleSubmit,
  contactUsLoading,
  onSubmit,
  register,
  errors,
}: {
  handleSubmit: any;
  contactUsLoading: boolean;
  onSubmit: (data: any) => void;
  register: any;
  errors: any;
}) => {
  return (
    <div
      className="modal custom-modal fade check-availability-modal"
      id="enquiry"
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered modal-md">
        <div className="modal-content py-0">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-4 d-flex justify-content-end"></div>
                <div className="col-md-4 text-center">
                  <h4 className="mb-0  fw-bold text-uppercase py-3">
                    Get in touch!
                  </h4>
                </div>
                <div className="col-md-4 d-flex justify-content-end">
                  <span
                    className="align-center text-black d-none d-md-flex fs-xx-large"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    aria-hidden="true"
                  >
                    ×
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 text-center my-3">
                  <img src="/assets/img/enquiry.png" alt="Img" />
                </div>
              </div>

              <div className="row">
                <div className="col-md-3"></div>
                <div className="col-md-6">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="input-block">
                        <input
                          type="text"
                          className={`form-control mb-0 py-2 ${errors.name ? "is-invalid" : ""}`}
                          placeholder="Name *"
                          {...register("name")}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="input-block">
                        <input
                          type="text"
                          className={`form-control mb-0 py-2 ${errors.email ? "is-invalid" : ""}`}
                          placeholder="Email *"
                          {...register("email")}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="input-block">
                        <input
                          type="number"
                          className={`form-control mb-0 py-2 ${errors.phone ? "is-invalid" : ""}`}
                          placeholder="Mobile"
                          {...register("phone")}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="input-block">
                        <textarea
                          className={`form-control mb-0 py-2 ${errors.message ? "is-invalid" : ""}`}
                          rows={4}
                          cols={50}
                          placeholder="Message"
                          defaultValue={"\t\t\t\t\t\t\t\t\t\t\t"}
                          {...register("message")}
                        />
                      </div>
                    </div>
                    <div className="col-md-12">
                      <button
                        type="submit"
                        className="btn btn-primary w-100 py-1"
                        disabled={contactUsLoading}
                      >
                        {" "}
                        {contactUsLoading ? "Sending.." : "Submit Enquiry"}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
